"use client";

import { DirectusImage } from "@/components/DirectusImage";
import { useCurrentLocale } from "@/hooks/useCurrentLocale";
import { getDecimals } from "@/lib/utils";
import { useScopedI18n } from "@/messages/client";
import { Fragment } from "react";
import CountUp from "react-countup";

export default function AboutCompany(props : {
  data?: {
    title?: string;
    description?: string;
    image?: string;
    data_list?: {
      name?: string;
      value?: number;
      unit?: string;
      icon?: string;
    }[];
  }
}) {
  const t = useScopedI18n("POWERQUARK简介");
  const locale = useCurrentLocale()
  return (
    <div className="w-full">
      <div className="flex flex-col md:gap-x-[60px] xl:gap-x-[120px] gap-y-5 md:flex-row">
        <div className="flex-auto">
          <div className="flex items-center text-xs md:text-2xl">
            {
              locale === "cn" ? 
                <>
                  公司介绍
                  <hr className="h-2.5 border-l mx-2.5 md:mx-7 md:h-6 " />
                  About us
                </> : 
                "About us"
            }
          </div>
          <h2 className="mt-2 text-lg font-bold md:mt-6 md:text-5xl md:leading-tight md:whitespace-pre-line zh:tracking-[1.6rem]">
            {props.data?.title}
          </h2>
          <hr className="border-b border-zinc-400 mt-6 mb-12 max-md:hidden" />
          <p className="text-sm whitespace-pre-line md:text-base max-md:mt-5 text-[#282938] !leading-loose zh:text-justify">
            {props.data?.description}
          </p>
        </div>
        <div className="shrink-0 md:w-[440px] xl:w-[540px]">
          <div className="w-full">
            {props.data?.image && (
              <DirectusImage
                id={props.data?.image || ""}
                alt={t("公司介绍")}
                width={540}
                height={332}
                className="w-full object-cover"
              />
            )}
          </div>
          <div className="flex justify-between items-center mt-7 md:mt-14 md:px-5">
            {props.data?.data_list?.map((el, index) => (
              <Fragment key={index}>
                {index !== 0 && (
                  <hr className="mx-8 h-[30px] border-l border-zinc-400 xl:mx-14- md:h-[60px]" />
                )}
                <div>
                  <span className="text-[#FF5100] font-bold text-2xl md:text-3xl">
                    <CountUp
                      start={0}
                      end={el.value || 0}
                      decimals={getDecimals(el.value || 0)}
                      separator={""}
                      enableScrollSpy
                      scrollSpyOnce
                    />
                    {el.unit && (
                      <span className="ml-1.5 text-xs md:text-xl">{el.unit}</span>
                    )}
                  </span>
                  <div className="flex items-center mt-1 text-xs md:text-sm">
                    {el.icon && (
                      <DirectusImage
                        id={el.icon}
                        alt={el.name || ""}
                        width={16}
                        height={16}
                        className="mr-1 md:mr-1.5"
                      />
                    )}
                    {el.name}
                  </div>
                </div>
              </Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
